// extracted by mini-css-extract-plugin
export default {"modalBody":"order-details_modalBody__mR7SK","numberOrder":"order-details_numberOrder__Bp7Li"};